import { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";
import Box from "@mui/material/Box";

// Pétales qui tombent lentement avec un balancement — fond romantique.
interface PetalsProps {
  count?: number;
  /** opacité globale (utile pour un fond très subtil sur fond clair) */
  opacity?: number;
}

export default function Petals({ count = 14, opacity = 1 }: PetalsProps) {
  const reduce = useReducedMotion();

  const petals = useMemo(
    () =>
      Array.from({ length: count }).map(() => ({
        left: Math.random() * 100,
        size: 9 + Math.random() * 15,
        delay: Math.random() * 9,
        duration: 9 + Math.random() * 9,
        sway: 18 + Math.random() * 46,
        rotate: Math.random() * 360,
      })),
    [count]
  );

  if (reduce) return null;

  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1,
        opacity,
      }}
    >
      {petals.map((p, i) => (
        <motion.span
          key={i}
          initial={{ y: "-12vh", x: 0, opacity: 0, rotate: p.rotate }}
          animate={{
            y: "112vh",
            x: [0, p.sway, -p.sway / 2, p.sway, 0],
            opacity: [0, 0.9, 0.85, 0.6, 0],
            rotate: p.rotate + 200,
          }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.7,
            borderRadius: "60% 60% 60% 0 / 70% 70% 70% 0",
            background:
              "linear-gradient(135deg, rgba(231,216,196,0.95), rgba(191,160,106,0.65))",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        />
      ))}
    </Box>
  );
}
